export default {
      id: "download-usage",
      viewBox: "0 0 14 20",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#download",
      toString: function () {
        return this.url;
      }
    }